import React from "react";
import {
  WMS_LGS_DAFTAR_MUTASI_ITEM,
  WMS_LGS_GOL_BARANG,
  WMS_LGS_HISTORY_STOK,
  WMS_LGS_INPUT_REQUEST_MUTASI,
  WMS_LGS_INVENTORY_CONTROL,
  WMS_LGS_KARTU_STOK,
  WMS_LGS_LAPORAN_STOK,
  WMS_LGS_MS_BARANG,
  WMS_LGS_MS_GUDANG,
  WMS_LGS_MS_SPB,
  WMS_LGS_MUTASI_ITEM,
  WMS_LGS_RECEIVE_REQUEST_MUTASI,
  WMS_LGS_RETUR_PEMBELIAN,
  WMS_SERVICE_TUTUP_PEMBELIAN_LOGISTIK,
} from "App/constants";
import {
  DaftarInventoryControlLogistik,
  DaftarMutasiItemLogistik,
  HistoryStokLogistik,
  InputReceiveMutasiLogistik,
  InputRequestMutasiLogistik,
  KartuStokLogistik,
  LaporanStokLogistik,
  MasterBarangLogistik,
  MasterGolonganBarangLogistik,
  MasterGudangLogistik,
  MutasiItemLogistik,
  ReturPembelianLogistik,
  ServiceTutupPembelianLogistik,
  StatusPengeluaranBarangLogistik,
} from "../WrapperLazyExport";


export const menuLogistik = {
  [WMS_LGS_DAFTAR_MUTASI_ITEM]: <DaftarMutasiItemLogistik />,
  [WMS_LGS_INPUT_REQUEST_MUTASI]: <InputRequestMutasiLogistik />,
  [WMS_LGS_RECEIVE_REQUEST_MUTASI]: <InputReceiveMutasiLogistik />,
  [WMS_LGS_MUTASI_ITEM]: <MutasiItemLogistik />,

  [WMS_LGS_INVENTORY_CONTROL]: <DaftarInventoryControlLogistik />,

  [WMS_LGS_MS_BARANG]: <MasterBarangLogistik />,
  [WMS_LGS_MS_GUDANG]: <MasterGudangLogistik />,
  [WMS_LGS_MS_SPB]: <StatusPengeluaranBarangLogistik />,

  [WMS_LGS_GOL_BARANG]: <MasterGolonganBarangLogistik />,
  [WMS_SERVICE_TUTUP_PEMBELIAN_LOGISTIK]: <ServiceTutupPembelianLogistik />,
  [WMS_LGS_RETUR_PEMBELIAN]: <ReturPembelianLogistik />,
  [WMS_LGS_HISTORY_STOK]: <HistoryStokLogistik />,
  [WMS_LGS_KARTU_STOK]: <KartuStokLogistik />,
  [WMS_LGS_LAPORAN_STOK]: <LaporanStokLogistik />,
};
